import { SvgIcon } from '@material-ui/core'

export default function MusicNoteIcon(props: any) {
    return (
        <SvgIcon style={{ width: '28px', height: '28px' }} viewBox="0 0 28 28" fill="none" {...props}>
            <foreignObject x="-36.2097" y="-38.544" width="101.588" height="105.088"></foreignObject>
            <path
                data-figma-bg-blur-radius="41.169"
                d="M14.0009 2.625C13.5176 2.625 13.1259 3.01675 13.1259 3.5V8.16667C13.1259 8.16651 13.1259 8.16682 13.1259 8.16667L13.1259 16.6361C12.2611 15.9015 11.1411 15.4583 9.91756 15.4583C7.17915 15.4583 4.95923 17.6783 4.95923 20.4167C4.95923 23.1551 7.17915 25.375 9.91756 25.375C12.656 25.375 14.8759 23.1551 14.8759 20.4167C14.8759 20.2781 14.8702 20.1408 14.8591 20.005C14.8701 19.9495 14.8759 19.8921 14.8759 19.8333L14.8759 9.04167H21.0009C22.7728 9.04167 24.2092 7.60525 24.2092 5.83333C24.2092 4.06142 22.7728 2.625 21.0009 2.625H14.0009Z"
                fill="url(#paint0_linear_1373_14870)"
            />
            <defs>
                <clipPath id="bgblur_0_1373_14870_clip_path" transform="translate(36.2097 38.544)">
                    <path d="M14.0009 2.625C13.5176 2.625 13.1259 3.01675 13.1259 3.5V8.16667C13.1259 8.16651 13.1259 8.16682 13.1259 8.16667L13.1259 16.6361C12.2611 15.9015 11.1411 15.4583 9.91756 15.4583C7.17915 15.4583 4.95923 17.6783 4.95923 20.4167C4.95923 23.1551 7.17915 25.375 9.91756 25.375C12.656 25.375 14.8759 23.1551 14.8759 20.4167C14.8759 20.2781 14.8702 20.1408 14.8591 20.005C14.8701 19.9495 14.8759 19.8921 14.8759 19.8333L14.8759 9.04167H21.0009C22.7728 9.04167 24.2092 7.60525 24.2092 5.83333C24.2092 4.06142 22.7728 2.625 21.0009 2.625H14.0009Z" />
                </clipPath>
                <linearGradient
                    id="paint0_linear_1373_14870"
                    x1="10.5195"
                    y1="2.62659"
                    x2="10.5195"
                    y2="33.0953"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0.15" />
                </linearGradient>
            </defs>
        </SvgIcon>
    )
}
